<template>
	<vxe-modal v-model="modal" title="付款汇款汇总" width="1200" height="600" @show="show" show-footer>
		<template #default>
			<p>
				<vxe-radio-group v-model="selectTab">
					<vxe-radio-button label="balance" content="账户明细"></vxe-radio-button>
					<vxe-radio-button label="purpose" content="按用途"></vxe-radio-button>
					<vxe-radio-button label="banktype" content="按类别"></vxe-radio-button>
<!-- 					<vxe-radio-button label="account" content="按账号"></vxe-radio-button>
					<vxe-radio-button label="date" content="按日期"></vxe-radio-button>
					<vxe-radio-button label="staff" content="按创建人"></vxe-radio-button> -->
				</vxe-radio-group>
			</p>
			<div v-if="selectTab=='balance'">
				<vxe-toolbar>
					<template #buttons>
						<vxe-button status="success" @click="paymentsummaryExport">导出</vxe-button>
					</template>
				</vxe-toolbar>
				<vxe-table ref="paymentsummary" border show-overflow
					height="400" :data="tableData" show-footer :footer-data="footerData">
					<vxe-column type="seq" width="60"></vxe-column>
					<vxe-column field="bankName" title="开户银行"></vxe-column>
					<vxe-column field="bankAcc" title="账号"></vxe-column>
					<vxe-column field="accName" title="账户名称"></vxe-column>
					<vxe-column sortable field="class" title="资金状态"></vxe-column>
					<vxe-column sortable field="bal" title="余额"></vxe-column>
				</vxe-table>
				
			</div>
			<div v-show="selectTab=='purpose'">
				<vxe-toolbar>
					<template #buttons>
						<vxe-button status="success" @click="paymentsummaryExport">导出</vxe-button>
					</template>
				</vxe-toolbar>
				<vxe-table ref="paymentsummary" footer-cell-class-name="footerCellColor" border show-overflow
					height="400" :data="tableData">
					<vxe-column type="seq" width="60"></vxe-column>
					<vxe-column sortable field="class" title="资金状态"></vxe-column>
					<vxe-column sortable field="bal" title="余额"></vxe-column>
				</vxe-table>
			</div>			
			<div v-show="selectTab=='banktype'">
				<vxe-toolbar>
					<template #buttons>
						<vxe-button status="success" @click="paymentsummaryExport">导出</vxe-button>
					</template>
				</vxe-toolbar>
				<vxe-table ref="paymentsummary" footer-cell-class-name="footerCellColor" border show-overflow
					height="400" :data="tableData">
					<vxe-column type="seq" width="60"></vxe-column>
					<vxe-column sortable field="bankType" title="银行"></vxe-column>
					<vxe-column sortable field="bal" title="余额"></vxe-column>
				</vxe-table>
			</div>			
			
			
<!-- 			<div v-show="selectTab=='account'">
				<vxe-toolbar>
					<template #buttons>
						<vxe-button status="success" @click="paymentsummaryExport">导出统计</vxe-button>
						<vxe-button status="primary" @click="paymentsummaryExportDetail"
							v-if="selectTab!='balance'">导出明细</vxe-button>
					</template>
				</vxe-toolbar>
				<vxe-table ref="paymentsummary" footer-cell-class-name="footerCellColor"
					:show-footer="true" :footer-method="accountFooterMethod" border show-overflow height="400"
					:data="tableData">
					<vxe-column type="seq" width="60"></vxe-column>
					<vxe-column field="accName" title="户名"></vxe-column>
					<vxe-column sortable field="ordernum" title="订单数量"></vxe-column>
					<vxe-column sortable field="amount" title="金额"></vxe-column>
				</vxe-table>
			</div>
			<div v-show="selectTab=='date'">
				<vxe-toolbar>
					<template #buttons>
						<vxe-button status="success" @click="paymentsummaryExport">导出统计</vxe-button>
						<vxe-button status="primary" @click="paymentsummaryExportDetail" >导出明细</vxe-button>
					</template>
				</vxe-toolbar>
				<vxe-table ref="paymentsummary" footer-cell-class-name="footerCellColor"
					:show-footer="true" :footer-method="dateFooterMethod" border show-overflow height="400"
					:data="tableData">
					<vxe-column type="seq" width="60"></vxe-column>
					<vxe-column field="accName" title="户名"></vxe-column>
					<vxe-column field="transTime" title="日期"></vxe-column>
					<vxe-column sortable field="ordernum" title="订单数量"></vxe-column>
					<vxe-column sortable field="amount" title="金额"></vxe-column>
				</vxe-table>
			</div>
			<div v-show="selectTab=='staff'">
				<vxe-toolbar>
					<template #buttons>
						<vxe-button status="success" @click="paymentsummaryExport">导出统计</vxe-button>
						<vxe-button status="primary" @click="paymentsummaryExportDetail" >导出明细</vxe-button>
					</template>
				</vxe-toolbar>
				<vxe-table ref="paymentsummary" footer-cell-class-name="footerCellColor"
					:show-footer="true" :footer-method="staffFooterMethod" border show-overflow height="400"
					:data="tableData">
					<vxe-column type="seq" width="60"></vxe-column>
					<vxe-column field="accName" title="户名"></vxe-column>
					<vxe-column field="purchasecreatorname" title="创建人"></vxe-column>
					<vxe-column sortable field="ordernum" title="订单数量"></vxe-column>
					<vxe-column sortable field="amount" title="金额"></vxe-column>
				</vxe-table>
			</div> -->
			<!-- 			<vxe-table v-show="selectTab=='balance'" ref="paymentsummary" footer-cell-class-name="footerCellColor"
				border show-overflow height="400" :data="tableData">
				<vxe-column type="seq" width="60"></vxe-column>
				<vxe-column field="accName" title="户名"></vxe-column>
				<vxe-column sortable field="bal" title="余额"></vxe-column>
				<vxe-column field="transTime" title="截止时间">
					<template #default="{ row }">
						<span>{{$systemMethods.timestampToDate(row.transTime)}}</span>
					</template>
				</vxe-column>
			</vxe-table> -->



		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="cancel"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			row: {
				default: () => {
					return null
				}
			},
			transTime: {
				default: () => {
					return null
				}
			},
			parentTable: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				sourcedata: [],
				selectTab: 'balance',
				modal: false,
				loading: false,
				tableData: [],
				balance: [],
				bankAccList: [],
				footerData:[{
					seq: '合计',
					bal:123123
				}],
				form: {
					mkcode: '',
					checkstaffid: null,
				},
			}
		},
		watch: {
			selectTab() {
				this.init()
			}
		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {
				this.tableData = []
				this.$api.reconciliation_bankflow.getSummary({
					transTime: this.transTime
				}).then((res) => {
					this.sourcedata = res.list
					this.balance = res.balance
					this.bankAccList = res.bankAccList
					if (this.selectTab == 'account') {
						this.tableData = this.accordingToAccount(res.list)
					}
					if (this.selectTab == 'date') {
						this.tableData = this.accordingToDate(res.list)
					}
					if (this.selectTab == 'staff') {
						this.tableData = this.accordingToStaff(res.list)
					}
					if (this.selectTab == 'balance') {
						this.tableData = this.accordingToBalance()
					}
					if (this.selectTab == 'purpose') {
						this.tableData = this.accordingToPurpose(res.list)
					}
					if (this.selectTab == 'banktype') {
						this.tableData = this.accordingToBanktype(res.list)
					}				
					
					
				})
			},
			accordingToAccount(data) {
				let tabledata = []
				let groupedData = this.$Lodash.groupBy(data, 'accName')

				// for (let i in groupedData) {
				// 	groupedData[i] = this.$Lodash.groupBy(groupedData[i], 'purchasestockbillstoragename')
				// }
				// for (let i in groupedData) {
				// 	for (let j in groupedData[i]) {
				// 		let obj = {}
				// 		obj.accName = i
				// 		obj.warehouse = j
				// 		obj.ordernum = this.$Lodash.sumBy(groupedData[i][j], item => parseFloat(item.cdSign))
				// 		obj.amount = this.$Lodash.sumBy(groupedData[i][j], item => parseFloat(item.amt))
				// 		obj.amount = obj.amount.toFixed(2)
				// 		tabledata.push(obj)
				// 	}
				// }

				for (let i in groupedData) {
					let obj = {}
					obj.accName = i
					obj.ordernum = this.$Lodash.sumBy(groupedData[i], item => parseFloat(item.cdSign))
					obj.amount = this.$Lodash.sumBy(groupedData[i], item => parseFloat(item.amt))
					obj.amount = obj.amount.toFixed(2)
					tabledata.push(obj)
				}

				return tabledata
			},
			accordingToDate(data) {
				let tabledata = []
				let groupedData = this.$Lodash.groupBy(data, 'accName')
				for (let i in groupedData) {
					groupedData[i] = this.$Lodash.groupBy(groupedData[i], 'transTime')
				}
				for (let i in groupedData) {
					for (let j in groupedData[i]) {
						let arr = this.accordingToAccount(groupedData[i][j])
						arr.forEach((item) => {
							item.transTime = j
						})
						tabledata = tabledata.concat(arr)
					}
				}
				return tabledata
			},
			accordingToStaff(data) {
				let tabledata = []
				let groupedData = this.$Lodash.groupBy(data, 'accName')
				for (let i in groupedData) {
					groupedData[i] = this.$Lodash.groupBy(groupedData[i], 'purchasecreatorname')
				}
				for (let i in groupedData) {
					for (let j in groupedData[i]) {
						let arr = this.accordingToAccount(groupedData[i][j])
						arr.forEach((item) => {
							item.purchasecreatorname = j
						})
						tabledata = tabledata.concat(arr)



						// let obj = {}
						// obj.purchasecreatorname = i
						// obj.warehouse = j
						// obj.ordernum = this.$Lodash.sumBy(groupedData[i][j], item => parseFloat(item.cdSign))
						// obj.amount = this.$Lodash.sumBy(groupedData[i][j], item => parseFloat(item.amt))
						// obj.amount = obj.amount.toFixed(2)
						// tabledata.push(obj)
					}
				}
				return tabledata
			},
			accordingToBalance() {
				let tabledata = []
				let bankAccList = this.$Lodash.groupBy(this.bankAccList, 'accName')
				// this.footerData = [
				// 	{ bal: this.$Lodash.sumBy(this.bankAccList, item => parseFloat(item.bal)) }
				// ]
				//console.log(bankAccList)
				for (let i in bankAccList) {
					//let totalbal = this.$Lodash.sumBy(bankAccList[i], item => parseFloat(item.bal))
					//totalbal = totalbal.toFixed(2)
					bankAccList[i].forEach((item) => {
						//item['totalbal'] = totalbal
						tabledata.push(item)
					})
				}

				return tabledata
			},
			accordingToPurpose() {
				let tabledata = []
				let bankAccList = this.$Lodash.groupBy(this.bankAccList, 'class')
				//console.log(bankAccList)
				for (let i in bankAccList) {
					tabledata.push({
						class:i,
						bal:(this.$Lodash.sumBy(bankAccList[i], item => parseFloat(item.bal))).toFixed(2)
					})
				}

				return tabledata
			},
			accordingToBanktype(){
				let tabledata = []
				let bankAccList = this.$Lodash.groupBy(this.bankAccList, 'bankType')
				//console.log(bankAccList)
				for (let i in bankAccList) {
					
					tabledata.push({
						bankType:i,
						bal:(this.$Lodash.sumBy(bankAccList[i], item => parseFloat(item.bal))).toFixed(2)
					})
				}
				
				return tabledata
			},
			spanMethod({
				row,
				_rowIndex,
				column,
				visibleData
			}) {
				let fields = ['class', 'totalbal']
				let cellValue = row[column.field]
				if (cellValue && fields.includes(column.field)) {
					let prevRow = visibleData[_rowIndex - 1]
					let nextRow = visibleData[_rowIndex + 1]
					if (prevRow && prevRow[column.field] === cellValue) {
						return {
							rowspan: 0,
							colspan: 0
						}
					} else {
						let countRowspan = 1
						while (nextRow && nextRow[column.field] === cellValue) {
							nextRow = visibleData[++countRowspan + _rowIndex]
						}
						if (countRowspan > 1) {
							return {
								rowspan: countRowspan,
								colspan: 1
							}
						}
					}
				}
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {
				this.init()
			},
			modalShow() {
				this.modal = true
			},
			paymentsummaryExport() {
				this.$refs.paymentsummary.exportData({
					type: 'xlsx'
				})
			},
			paymentsummaryExportDetail() {
				this.$emit('exportdetail', {
					data: this.sourcedata
				})
			},
			accountFooterMethod({
				data
			}) {
				let ordernum = 0
				let amount = 0
				data.forEach((item) => {
					ordernum += item.ordernum ? parseFloat(item.ordernum) : 0
					amount += item.amount ? parseFloat(item.amount) : 0
				})
				return [
					['合计', '', ordernum, amount.toFixed(2)]
				]
			},
			dateFooterMethod({
				data
			}) {
				let ordernum = 0
				let amount = 0
				data.forEach((item) => {
					ordernum += item.ordernum ? parseFloat(item.ordernum) : 0
					amount += item.amount ? parseFloat(item.amount) : 0
				})
				return [
					['合计', '', '', ordernum, amount.toFixed(2)]
				]
			},
			staffFooterMethod({
				data
			}) {
				let ordernum = 0
				let amount = 0
				data.forEach((item) => {
					ordernum += item.ordernum ? parseFloat(item.ordernum) : 0
					amount += item.amount ? parseFloat(item.amount) : 0
				})
				return [
					['合计', '', '', ordernum, amount.toFixed(2)]
				]
			},
			// spanMethod({
			// 	row,
			// 	_rowIndex,
			// 	column,
			// 	visibleData
			// }) {
			// 	const fields = ['accName']
			// 	const cellValue = row[column.property]
			// 	if (cellValue && fields.includes(column.property)) {
			// 		if (column.property == 'code' || column.property == 'commit_time' || column.property == 'img_file') {
			// 			const prevRow = visibleData[_rowIndex - 1]
			// 			let nextRow = visibleData[_rowIndex + 1]
			// 			if (prevRow && JSON.stringify(prevRow[column.property]) === JSON.stringify(cellValue)) {
			// 				return {
			// 					rowspan: 0,
			// 					colspan: 0
			// 				}
			// 			} else {
			// 				console.log(nextRow[column.property], cellValue)
			// 				let countRowspan = 1
			// 				while (nextRow && JSON.stringify(nextRow[column.property]) === JSON.stringify(cellValue)) {
			// 					nextRow = visibleData[++countRowspan + _rowIndex]
			// 				}
			// 				if (countRowspan > 1) {
			// 					return {
			// 						rowspan: countRowspan,
			// 						colspan: 1
			// 					}
			// 				}
			// 			}
			// 		} else {
			// 			if (!(_rowIndex % 2)) {
			// 				return {
			// 					rowspan: 2,
			// 					colspan: 1
			// 				}
			// 			} else {
			// 				return {
			// 					rowspan: 0,
			// 					colspan: 0
			// 				}
			// 			}
			// 		}
			// 	}
			// },
		},
		components: {

		}
	}
</script>